import React, { createContext, useState, useContext } from 'react';

// Creamos el contexto
const AuthContext = createContext();

// Creamos el provider
export const AuthProvider = ({ children }) => {
  const [empresa, setEmpresa] = useState({id:null,nombre:null, userId:null});
  
  const [hasLogin, setHasLogin] = useState(false);


  
  const [empleado, setempleado] = useState({
    id:null,
    empresaId:null,
    token: null,
    userId:null,
    nombre:null,
    apellidos:null
  });
  const [hasLoginEmpleado, setHasLoginEmpleado] = useState(false);

  const login = (empresa) => {
    setEmpresa(empresa);
    setHasLogin(true);
  };

  const logOut = () => {
    localStorage.removeItem("token");
    setEmpresa({id:null,nombre:null});
    setHasLogin(false);
    setempleado({id:null,empresaId:null, token: null, userId:null, nombre:null, apellidos:null});
    setHasLoginEmpleado(false);
  };
  const Empleadologin = (empleado) => {
    setempleado(empleado);
    setHasLoginEmpleado(true);

  };



  return (
    <AuthContext.Provider value={{ empresa, hasLogin, login, logOut, empleado, hasLoginEmpleado, Empleadologin  }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook para acceder al contexto
export const useAuth = () => useContext(AuthContext);
